import { createContext } from 'react'

export interface SuperpowersContextValue {
  disablePortraitGeneration: boolean
  setDisablePortraitGeneration: (val: boolean) => void
}

export const SuperpowersContext = createContext<SuperpowersContextValue>({
  disablePortraitGeneration: false,
  setDisablePortraitGeneration: () => {},
})
